import React from "react";
import "../../components/layout/AppShell.css";

const release = {
  name: "JobTelesis v1.0 RC1",
  status: "In Progress",
  branch: "feature/job-costs-v1",
  mission: "What has JobTelesis proven?",
  summary:
    "Release Center records the evidence that JobTelesis is ready for real tenants.",
};

const certifications = [
  {
    name: "Core Operations",
    status: "Certified",
    proves:
      "Clients, jobs, estimates, invoices, payments, notes, and reports work as the operating workflow.",
    evidence: [
      "Home / Clients-Jobs is the operational center.",
      "Job detail keeps the JOB as the primary business record.",
      "Products & Services can feed estimates and invoices.",
      "Job Costs supports profitability review.",
    ],
  },
  {
    name: "Beta Customer Lifecycle",
    status: "Certified",
    proves:
      "A beta tenant can enter without Stripe and remain separate from paid public signup.",
    evidence: [
      "Beta signup route exists separately from paid signup.",
      "Beta controls manage availability and seat limits.",
      "Beta tenants are identified by lifecycle state.",
    ],
  },
  {
    name: "Infrastructure & Deployment",
    status: "Certified",
    proves:
      "Production can be deployed, verified, backed up, and corrected without guessing.",
    evidence: [
      "Production backend health check returns OK.",
      "Production database target verified as juliangonzales.",
      "Frontend deployment mismatch was diagnosed and corrected.",
      "Release Center rendering verified on production.",
    ],
  },
  {
    name: "Paid Customer Lifecycle",
    status: "In Progress",
    proves:
      "A new standard tenant can sign up through Stripe and only become active after successful checkout.",
    evidence: [
      "Stripe-first signup workflow exists.",
      "Old public signup bypass was identified as unsafe.",
      "Paid signup needs final production re-test before certification.",
    ],
  },
  {
    name: "Stripe Connect Lifecycle",
    status: "In Progress",
    proves:
      "A tenant can separately enable online invoice payments without changing subscription status.",
    evidence: [
      "Connect onboarding controls exist in Platform Headquarters.",
      "Connect status fields are tracked separately from subscription billing.",
      "Onboarding response now supports both url and onboarding_url.",
    ],
  },
  {
    name: "Subscription Lifecycle",
    status: "Pending",
    proves:
      "Trial, active, past due, billing required, canceled, and suspended states behave correctly.",
    evidence: [
      "Access status routing exists.",
      "Needs focused test matrix before tenant launch.",
    ],
  },
  {
    name: "Production Acceptance",
    status: "Pending",
    proves:
      "The live production site matches the certified release and is ready for tenants.",
    evidence: [
      "Needs final release checklist.",
      "Needs browser, mobile, Stripe, database, webhook, and rollback verification.",
    ],
  },
];

function statusStyle(status) {
  if (status === "Certified") return { background: "#14532d", color: "#bbf7d0" };
  if (status === "In Progress") return { background: "#78350f", color: "#fde68a" };
  return { background: "#334155", color: "#cbd5e1" };
}

export default function PlatformReleaseCenter() {
  const certifiedCount = certifications.filter((c) => c.status === "Certified").length;

  return (
    <div className="hq-page">
      <div className="hq-hero">
        <div>
          <p className="hq-eyebrow">Platform Headquarters</p>
          <h1>Release Center</h1>
          <p>{release.summary}</p>
        </div>
      </div>

      <section className="hq-card">
        <p className="hq-eyebrow">Release Candidate</p>
        <h2>{release.name}</h2>
        <p><strong>Status:</strong> {release.status}</p>
        <p><strong>Branch:</strong> {release.branch}</p>
        <p><strong>Mission:</strong> {release.mission}</p>
        <p>
          <strong>Certified:</strong> {certifiedCount} of {certifications.length}
        </p>
      </section>

      <section className="hq-card">
        <p className="hq-eyebrow">Release Certifications</p>
        <h2>What JobTelesis Has Proven</h2>

        <div style={{ display: "grid", gap: 14, marginTop: 16 }}>
          {certifications.map((cert) => (
            <div
              key={cert.name}
              style={{
                padding: 16,
                borderRadius: 16,
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.08)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 12,
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                }}
              >
                <div>
                  <h3 style={{ margin: 0 }}>{cert.name}</h3>
                  <p style={{ marginBottom: 0 }}>{cert.proves}</p>
                </div>

                <span
                  style={{
                    ...statusStyle(cert.status),
                    padding: "6px 10px",
                    borderRadius: 999,
                    fontWeight: 800,
                    whiteSpace: "nowrap",
                  }}
                >
                  {cert.status}
                </span>
              </div>

              <div style={{ marginTop: 14 }}>
                <strong>Evidence</strong>
                <ul style={{ marginTop: 8 }}>
                  {cert.evidence.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
